<template>
  <el-dialog :title="title" :visible.sync="Visible" width="95vw" top="2vw" center class="ac-dialog"
    :close-on-click-modal="false" @close="close">
    <el-form :inline="true" :model="form" class="demo-form-inline" label-width="120px" label-position="right">
      <el-row :gutter="24">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="标题">
            <el-input v-model="form.title" style="width: 315px" />
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="内容">
            <el-input v-model="form.content" style="width: 315px" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="封面">
            <decrypt-img style="width: 300px; height: 300px; margin: 0 auto" :noNeedDoamin="true" :src="form.img">
            </decrypt-img>
          </el-form-item>
        </el-col>
        <!-- <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="上架状态">
            <el-switch
v-model="form.status"
active-color="#13ce66"
inactive-color="#ff4949"
              style="width: 180px"></el-switch>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="付费类型">
            <el-switch
v-model="form.update_status"
active-color="#13ce66"
inactive-color="#ff4949"
              style="width: 180px"></el-switch>
          </el-form-item>
        </el-col> -->
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="分类">
            <el-tag :key="index + 'tagData'" style="margin: 2px" v-for="(item, index) in form.categories" size="mini">
              {{ item.name }}
            </el-tag>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8">
          <el-form-item label="更新时间">
            <el-date-picker style="width: 180px" v-model="form.time" type="date" placeholder="选择日期"
              value-format="yyyy-MM-ddTHH:mm:ssZ">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="节点内容">
            <div class="itemData-main">
              <div class="postContent">
                <div class="postBox" v-for="(item, index) in form.files" :key="index">
                  <!-- <p class="postTitle">{{ item.title }}</p> -->
                  <decrypt-img :noNeedDoamin='true' :src="item.image" />
                  <!-- <span class="postText">{{ item.text }}</span> -->
                  <DPlayer ref="player" class="dplayerBox" v-if="item.video_link" :video="{
                    url: filterM3u8(item.video_link),
                    type: 'hls',
                    pic: '',
                  }" hotkey></DPlayer>
                </div>
              </div>
            </div>
          </el-form-item>

        </el-col>
      </el-row>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click.native.prevent="Visible = false"> 取 消 </el-button>
    </div>

  </el-dialog>
</template>
<script>
import DPlayer from '@/components/VueDplayerHls/index'
import 'videojs-contrib-hls'
import API from '@/api'


export default {
  name: 'AddOrEdit',
  props: ['data'],
  components: {
    DPlayer,
  },

  data() {
    return {
      coverTypeList: [
        { label: '横版', value: 'long' },
        { label: '竖版', value: 'short' },
      ],

      type: undefined,
      videoType: undefined,
      innerVisible: false,
      Visible: true,
      title: '',

      taskId: '',
      tags: null,
      fieldNameFs: '', // 正片地址全称
      form: {
        links: [{
          m3u8_url: '',
          preview_m3u8_url: '',
        }]
      },

    }
  },

  async created() {
    this.title = this.data.title
    if (this.title === '查看详情') {
      await this.getVideoDetail()
      if (this.form.links.m3u8_url) {
        this.open()
      }
    }
    if (this.player) {
      this.player.dispose()
    }
  },
  methods: {
    getVideoDetail() {
      API.lsjPostDetail({ id: this.data.data.id }).then((res) => {
        if (res.code === 200) {
          this.form = res.data
        } else {
          this.$message.error('请求失败!')
        }
      })
    },

    filterM3u8(v) {
      return /\.m3u8/g.test(v) ? v : v + '.m3u8'
    },
    // 清空某一项筛选列表
    onClear(key) {
      this.form.param[key] = []
    },

    // 上传图片返回地址
    changeCoverImgUrl(data) {
      this.form.coverImg = data
    },
    // / 监听视频播放的回调函数
    onPlayerPlay() { },
    // / 监听暂停播放的回调函数
    onPlayerPause() { },
    // / 监听当前视频数据加载完成
    onPlayerLoadeddata() { },
    // / 监听当前视频数据加载失败
    onPlayerError() { },
    // / 监听当前视频数据加载ing
    onPlayerWaiting() { },
    // / 监听当前视频播放完成
    onPlayerEnded() { },
    open() {
      this.mediaUrl =
        'api/web/media/m3u8/' +
        (this.form.links[0].m3u8_url.match(RegExp(/.m3u8/))
          ? this.form.links[0].m3u8_url
          : this.form.links[0].m3u8_url + '.m3u8')
      // this.$nextTick(function () {
      //   document.getElementById("media-box").innerHTML =
      //     '<video  id="my-video"  class="video-js vjs-default-skin"  controls preload="auto" style="width:100%;height:100%; "  playsinline="true"></video>';
      //   this.player = videojs("my-video", {
      //     bigPlayButton: false,
      //     textTrackDisplay: false,
      //     posterImage: true,
      //     errorDisplay: true,
      //     controlBar: true,
      //     playbackRates: [0.5, 1, 1.5, 2, 3, 5, 10],
      //   });
      //   this.player.src(this.mediaUrl);
      // });
    },

    // 关闭编辑
    close() {
      if (this.player) {
        this.player.dispose()
      }
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

.videoBox {
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.el-textarea.is-disabled.ti .el-textarea__inner {
  color: red;
}

.media-box {
  width: 100%;
  height: 400px;
  text-align: center;
  overflow: hidden;

  img {
    height: 100%;
    max-width: 100%;
  }

  #my-video {
    width: 100% !important;
    height: 100% !important;
    border: none !important;
  }
}

.check_upload {
  position: relative;
  padding: 10px;
  overflow: hidden;
  border: 1px dashed #ccc;
  background-color: #f5f5f5;

  div {
    display: inline-block;
    position: relative;
    padding: 4px 8px;
    font-size: 100%;
    line-height: 1.4;
    color: #666;
    border: 1px solid #666;
    cursor: pointer;
    border-radius: 2px;
    background: none;
    outline: none;
  }

}

.ac-dialog .itemData-main {
  /* rem适配基础设置 */
  font-size: 16px;
  /* 基准字体大小 */
  background: #000;
  color: #fff;
  height: auto;
  width: 500px;
  overflow-y: scroll;
  padding: 10px;

  a,
  a:link,
  a:visited,
  a:hover,
  a:active {
    text-decoration: none;
    color: inherit;
  }

  .topBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    background: #212121;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
    /* display: none; */
  }

  .navBtn {
    width: 51px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: #E0E0E0;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.10);
  }

  .navBtn .moreIcon {
    width: 16px;
    height: 16px;
    margin-right: 3px;
  }

  .logo {
    width: 94px;
    height: 32px;
  }

  .searchIcon {
    width: 24px;
    height: 24px;
    margin-left: 27px;
  }

  .header {
    width: 100%;
    /* height: 159px; */
    background: #212121;
    padding: 12px 16px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .header .title {
    text-align: center;
    color: #BDBDBD;
    font-size: 26px;
    line-height: 32px;
    margin-bottom: 14px;
  }

  .header .info {
    font-size: 14px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.70);
    display: flex;
    align-items: center;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .header .info a {
    text-decoration-line: underline;
  }

  .main .lineBox {
    padding: 0 16px;
    box-sizing: border-box;
  }

  .main .lineBox .line {
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.10);
    margin: 18px 0;
  }

  .postContent {
    margin: 36px 0 0;
  }

  .postBox {
    color: #FAFAFA;
    /* margin-bottom: 18px; */
  }

  .postTitle {
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    margin-bottom: 28px;
    padding: 0 16px;
    box-sizing: border-box;
  }

  .postText {
    color: #FAFAFA;
    margin: 0 16px 36px;
    font-size: 16px;
    line-height: 22px;
  }

  .postimage {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
    /* margin-bottom: 47px; */
  }

  .postDesc {
    font-size: 16px;
    color: #FAFAFA;
    line-height: 22px;
    padding: 0 16px;
    box-sizing: border-box;
    margin-bottom: 19px;
  }

  .postDesc span {
    font-weight: 600;
  }

  .postLine {
    margin: 0 16px;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.50);
  }

  .tagBox {
    margin-bottom: 12px;
    padding: 0 16px;
  }

  .tagBox .tagList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 7px;
    margin-bottom: 18px;
  }

  .tagBox .tagList .tagItem {
    padding: 8px 16px;
    box-sizing: border-box;
    border-radius: 62px;
    background: rgba(255, 255, 255, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #BDBDBD;
  }

  .lastDay {
    text-align: right;
    color: #BDBDBD;
    line-height: 20px;
    font-size: 14px;
  }

  .copyBox {
    color: #FFF;
    text-align: center;
    text-shadow: 0 0 20px #FF8400, 0 0 20px #FF8400;
    font-family: "PingFang SC";
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    /* 140% */
    padding: 18px;
    box-sizing: border-box;
    margin-bottom: 18px;
  }

  .copySuccess {
    color: #FFF;
    text-align: center;
    text-shadow: 0 0 20px #FF00B2, 0 0 20px #FF00B2;
    font-family: "PingFang SC";
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    /* 140% */
    padding: 18px;
    box-sizing: border-box;
    margin-bottom: 18px;
  }

  .dplayerBox {
    margin-bottom: 18px;
    max-height: 300px;
  }

  .gridAdvBox {
    margin: 0 16px 18px;
  }

  .gridAdvBox .gridAdvTitle {
    padding: 0 16px;
    box-sizing: border-box;
    height: 49px;
    display: flex;
    align-items: center;
    border-top: 1px solid rgba(255, 255, 255, 0.10);
    background: rgba(255, 255, 255, 0.05);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }

  .keywords {
    box-sizing: border-box;
    font-size: 16px;
    line-height: 22px;
    color: #BDBDBD;
  }

  @media screen and (min-width: 768px) {

    /* body {
    margin-top: 140px;
  } */
    body main {
      max-width: 720px;
      margin: 0 auto;
    }

    .header {
      max-width: 720px;
      margin: 0 auto;
    }

    .topBox {
      display: none;
    }
  }
}
</style>
